module.exports = __webpack_public_path__ + "img/tatargurkenrollseitlich.1c61688a.png";